export default {
  required: 'This field is required',
};
